// Botão livre da tela: o rótulo e a ação vêm da configuração.
import React from "react";
import * as Styles from "../../styles/PointOfSale.styles";

export const BotaoDeAcao: React.FC<{
  component: any;
  componentProps: any;
  buttonLabel: any;
  handleButtonClick: (acao: string, event?: React.MouseEvent) => void;
}> = ({
  component,
  componentProps,
  buttonLabel,
  handleButtonClick,
}) => {
  return (
    <Styles.Button
      tabIndex={-1}
      selected={Boolean(component.componentSelected)}
      id={String(component.componentId)}
      componentPosition={componentProps.componentPosition}
      componentBrightness={String(componentProps.componentBrightness)}
      componentWidth={String(componentProps.componentWidth)}
      componentHeight={String(componentProps.componentHeight)}
      componentStatus={String(componentProps.componentStatus)}
      componentBackgroundColor={String(
        componentProps.componentBackgroundColor
      )}
      componentColor={String(componentProps.componentColor)}
      onClick={(event) => {
        handleButtonClick(
          componentProps.componentAction as string,
          event as any
        );
      }}
    >
      {component.componentSelected && (
        <Styles.SelectedIcon
          top={component.componentProps.componentPosition.y}
          left={component.componentProps.componentPosition.x}
        >
          zoom_out_map
        </Styles.SelectedIcon>
      )}
      {componentProps.componentShortcut !== "" ? (
        <>
          <span className="buttonLabel">{buttonLabel}</span>
          <Styles.Divider orientation={"vertical"} />
          <span className="shortcut">
            {componentProps.componentShortcut}
          </span>
        </>
      ) : (
        <>
          <span className="buttonLabel">{buttonLabel}</span>
        </>
      )}
    </Styles.Button>
  );
};
